import { FC } from "react";

import { Stack } from "@mui/material";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { DashboardAvatar } from "@/dashboard-design-system/DashboardAvatar";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface UserMessageProps {
  text: string;
}

export const UserMessage: FC<UserMessageProps> = ({ text }) => {
  const { currentUser } = useCurrentUserContext();
  const initials = `${currentUser?.firstName?.[0] ?? ""}${currentUser?.lastName?.[0] ?? ""}`.toUpperCase();
  return (
    <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="flex-end" sx={{ pl: 8 }}>
      <Stack
        sx={(theme) => ({
          minWidth: 0,
          px: 1.5,
          py: 1,
          borderRadius: theme.radius(2),
          bgcolor: theme.palette.surface.brand.intense,
        })}
      >
        <DashboardTypography
          variant="body2"
          vibe="text-reverse-intense"
          sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
        >
          {text}
        </DashboardTypography>
      </Stack>
      <DashboardAvatar size="large" fallbackInitials={initials || undefined} sx={{ flexShrink: 0 }} />
    </Stack>
  );
};
